/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
      // Bind methods for cleanup
      this.onClick = this.onClick.bind(this);
      this.checkVisible = this.checkVisible.bind(this);
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.checkVisible);

      this.checkVisible();
    }

    disconnectedCallback() {
      this.toggle.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.checkVisible);
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      this.classList.toggle('max-height--enabled');
    }
  }
  customElements.define('max-height', MaxHeight);
}
